import React from "react";

const AboutDedication = () => {
  return (
    <article className="about__dedication">
      <div className="black-glass"></div>
      <section className="about__dedication__content">
        <h2 className="sub-title">Unsere Hingabe</h2>
        <h3>Momente schaffen, Verbindungen aufbauen</h3>
        <p>
          Unsere Reise basiert auf einem unerschütterlichen Engagement für Exzellenz – sowohl beim Essen, das wir servieren, als auch bei den Erlebnissen, die wir schaffen. Jedes Gericht auf unserer Speisekarte, von handgemachten Pizzen über frische Salate bis hin zu herzhaften Pasta-Gerichten, wird mit den besten regionalen Zutaten zubereitet und spiegelt unsere Leidenschaft für Qualität in jedem Bissen wider.
        </p>
        <p>
          Doch außergewöhnliches Essen ist nur ein Teil unseres Versprechens. Wahre Gastfreundschaft geht für uns über den Teller hinaus. Es geht darum, eine einladende Atmosphäre zu schaffen, in der sich jeder Gast wertgeschätzt fühlt, jeder Besuch besonders ist und jedes Essen Menschen zusammenbringt. Unser engagiertes Team steht im Mittelpunkt dieser Vision und arbeitet unermüdlich daran, Wärme, Verbundenheit und ein Gefühl der Zugehörigkeit zu schaffen – Teller für Teller.
        </p>
      </section>
    </article>
  );
}

export default AboutDedication;
